
import $ from 'jquery';
/**
 * Usage:
 * <button class="js-toggle" aria-controls="my-element">Toggle me</button>
 * <div id="my-element">I should be toggled</div>
 */
const toggle = {
  init: function() {
    $(document).on('click', '.js-toggle', function(e) {
      const $toggleTarget = $('#' + $(this).attr('aria-controls'));

      if($toggleTarget) {
        $(this).toggleClass('toggled');
        $toggleTarget.toggleClass('toggled');
      }
    });
  }
};

module.exports = toggle;
